export default "__VITE_ASSET__126d2d2d__"